import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames/bind';
import { func, node, string } from 'prop-types';
import useStyles from 'hooks/useStyles';

import styles from './FullMask.scss';

const cx = classnames.bind(styles);

export default function FullMask({ className, children, onClickShadow }) {
  useStyles(styles);

  useEffect(() => {
    // lock the background to prevent scroll
    window.document.querySelector(':root').classList.add(styles.lockScroll);
    window.document.body.classList.add(styles.lockScroll);

    return () => {
      window.document
        .querySelector(':root')
        .classList.remove(styles.lockScroll);
      window.document.body.classList.remove(styles.lockScroll);
    };
  }, []);

  return ReactDOM.createPortal(
    <div className={styles.wrapper}>
      <div className={cx(styles.shadow, className)} onClick={onClickShadow} />
      {children}
    </div>,
    document.querySelector('#modal'),
  );
}

FullMask.propTypes = {
  children: node.isRequired,
  className: string,
  onClickShadow: func,
};

FullMask.defaultProps = {
  className: '',
  onClickShadow: null,
};
